var React = require('react');

function DropdownArrowInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.24591 7.5C5.86101 8.16667 4.89876 8.16667 4.51386 7.5L1.04976 1.5C0.664855 0.833335 1.14598 8.94676e-07 1.91578 8.27378e-07L8.84398 2.21695e-07C9.61378 1.54397e-07 10.0949 0.833333 9.71001 1.5L6.24591 7.5Z","fill":"#898989"}));
}

DropdownArrowInline.defaultProps = {"width":"10","height":"8","viewBox":"0 0 10 8","fill":"none"};

module.exports = DropdownArrowInline;

DropdownArrowInline.default = DropdownArrowInline;
